import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Navbar.module.css';

const Navbar: React.FC = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <nav className={styles.navbar}>
            <div className={styles.container}>
                {/* Logo */}
                <Link to="/" className={styles.logo}>
                    <img src="/assets/LOGO.png" alt="BDLINK LIVE" className={styles.logoImage} />
                </Link>

                {/* Mobile Menu Toggle */}
                <button 
                    className={styles.mobileToggle}
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    aria-label="Toggle menu"
                >
                    {mobileMenuOpen ? '✕' : '☰'}
                </button>

                {/* Navigation Links */}
                <ul className={`${styles.navLinks} ${mobileMenuOpen ? styles.active : ''}`}>
                    <li>
                        <Link to="/" className={styles.navLink} onClick={() => setMobileMenuOpen(false)}>
                            <span className={styles.icon}>🏠</span>
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link to="/events" className={styles.navLink} onClick={() => setMobileMenuOpen(false)}>
                            <span className={styles.icon}>📅</span>
                            Events
                        </Link>
                    </li>
                    <li>
                        <a href="#about" className={styles.navLink} onClick={() => setMobileMenuOpen(false)}>
                            <span className={styles.icon}>ℹ️</span>
                            About
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;